<template>
  <div class="evaluation-section">
    <header>
      <div class="index-wrapper">
        <span class="index">{{ currentIndex }}</span>
      </div>
      <div class="title-wrapper">
        <h2>{{ item.name }}</h2>
        <p
          v-html="item.description"
          class="description"/>
      </div>
    </header>

    <main>
      <div
        class="questions-wrapper"
        v-if="item.$children"
      >
        <evaluation-question
          @comment="onComment"
          @evidence="onEvidence"
          v-for="(question, $index) of item.$children"
          :branch-type="branchType"
          :key="question.$id"
          :index="[...index, $index]"
          :item="question"
        />
      </div>
    </main>

  </div>
</template>

<script>
import EvaluationQuestion from './evaluation-question'

export default {
  name: 'EvaluationSection',
  components: { EvaluationQuestion },
  props: {
    index: {
      type: Array,
      default () {
        return []
      }
    },
    item: {
      type: Object,
      required: true,
      default () {
        return {}
      }
    },
    branchType: {
      type: String,
      required: true
    }
  },
  computed: {
    currentIndex () {
      let result = ''
      for (let i = 0; i < this.index.length; i++) {
        result += this.index[i] + 1 + '.'
      }
      return result.slice(0, -1)
    }
  },
  methods: {
    onComment (item) {
      this.$emit('comment', item)
    },
    onEvidence (item) {
      this.$emit('evidence', item)
    }
  }
}
</script>

<style
  lang="scss"
  scoped
>
.evaluation-section {
  padding: 40px;
  border-bottom: 1px solid #dddddd;
  header {
    display: flex;
    .index-wrapper {
      width: 60px;
      float: left;
      .index {
        @include font-primary(12px, bold);
        display: inline-block;
        background-color: $color-ui-primary;
        color: #fff;
        box-shadow: 0 3px 3px rgba(0, 0, 0, 0.2);
        padding: 5px;
        min-width: 14px;
        text-align: center;
        border-radius: 2px;
        vertical-align: middle;
      }
    }
    .title-wrapper {
      flex-grow: 1;
      h2 {
        @include font-primary(16px, semibold);
        color: #444444;
        margin: 0;
      }
      p.description {
        font-size: 12px;
        color: #444444;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/evaluation/components/layout/evaluation-section.vue